import { render, staticRenderFns } from "./DocumentosGrafico.vue?vue&type=template&id=2ca23a45&scoped=true"
import script from "./DocumentosGrafico.vue?vue&type=script&lang=js"
export * from "./DocumentosGrafico.vue?vue&type=script&lang=js"
import style0 from "./DocumentosGrafico.vue?vue&type=style&index=0&id=2ca23a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca23a45",
  null
  
)

export default component.exports